import React, { useCallback, useState } from 'react';

import { Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

import { usePetitionDetailsPageData, usePetitionDetailsPageUserData } from '#src/app/pages/petitionDetails/pageContext';

import { AiSummary } from '../aiSummary';

import { CardsPaginationDots } from './components/CardsPaginationDots';
import { ChangeAmbassadorDisclosure } from './components/ChangeAmbassadorDisclosure';
import { DescriptionContent } from './components/DescriptionContent';

export const DescriptionContainer: React.FC = () => {
	const {
		data: {
			experiments: { aiSummaries, petitionPageAiSummaryCardsExperimentEnabled },
		},
	} = usePetitionDetailsPageUserData();
	const {
		data: {
			petition: {
				isAmbassadorPetition,
				user: { displayName },
			},
		},
	} = usePetitionDetailsPageData();

	// Only ever set by AiSummary's cards-enabled (carousel) presentation -- see the Figma
	// annotation on node 614:63960 ("Carousel dots added to 'The issue' headline").
	const [cardsPagination, setCardsPagination] = useState<{ activeIndex: number; totalItems: number } | null>(null);
	const handleCardsActiveIndexChange = useCallback((activeIndex: number, totalItems: number) => {
		setCardsPagination({ activeIndex, totalItems });
	}, []);

	const showCardsPaginationDots =
		petitionPageAiSummaryCardsExperimentEnabled && !!cardsPagination && cardsPagination.totalItems > 1;

	return (
		<div data-qa="description-section">
			{showCardsPaginationDots ? (
				<div className="mb-10 flex items-center justify-between">
					<Text as="h2" size="x-large" fontWeight="normal" variant="heading">
						<Translate value="corgi.petition_gamma.details.description_title" />
					</Text>
					<CardsPaginationDots activeIndex={cardsPagination.activeIndex} totalItems={cardsPagination.totalItems} />
				</div>
			) : (
				<Text as="h2" className="mb-10" size="x-large" fontWeight="normal" variant="heading">
					<Translate value="corgi.petition_gamma.details.description_title" />
				</Text>
			)}

			{aiSummaries && <AiSummary onCardsActiveIndexChange={handleCardsActiveIndexChange} />}

			<DescriptionContent />

			{isAmbassadorPetition && <ChangeAmbassadorDisclosure starterName={displayName} />}
		</div>
	);
};
